import { TrendingUp, TrendingDown } from "../common/icons";

export function KPICard({
  label,
  value,
  status,
  changePercentage,
  history,
  secondaryValue,
  currency,
  loading,
}) {
  let max = 0;
  let min = 0;
  let range = 0;
  if (history && history.length > 0) {
    max = Math.max(...history);
    min = Math.min(...history);
    range = max - min;
  }

  const hasCurrency = Boolean(currency);
  const formattedValue =
    typeof value === "number"
      ? hasCurrency
        ? formatMoney(value, currency)
        : value.toLocaleString()
      : value;

  function formatMoney(amount, currency = "NGN", locale = "en-US") {
    let formatted = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
    if (currency === "NGN") {
      formatted = formatted.replace(/^NGN/, "₦");
    } else if (currency === "USD") {
      formatted = formatted.replace(/^USD/, "$");
    }

    return formatted;
  }

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100 hover:border-blue-200 hover:shadow-md transition-all duration-200">
      <div className="space-y-3">
        {/* Label */}
        <div className="text-sm text-gray-500 font-medium">{label}</div>

        {/* Value and Status Row */}
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1 min-w-0">
            <div className="text-2xl font-semibold text-gray-900 truncate">
              {formattedValue}
            </div>
            {secondaryValue && (
              <div className="text-sm text-gray-500 mt-1">{secondaryValue}</div>
            )}
          </div>

          <div
            className={`flex items-center  text-sm font-medium whitespace-nowrap ${
              status === "up" ? "text-green-600" : "text-red-600"
            }`}
          >
            {status === "up" ||
            status === "upward" ||
            status?.startsWith("up") ? (
              <div className="flex items-center gap-1">
                <TrendingUp size={16} /> {"+"}
              </div>
            ) : (
              <div>
                <TrendingDown size={16} /> {"-"}
              </div>
            )}
            <span>
              {changePercentage}
              {"%"}
            </span>
          </div>
        </div>

        {/* History Bar Chart */}
        {history?.length > 0 && (
          <div className="h-8 flex items-end gap-0.5">
            {history.map((value, index) => {
              const height = range > 0 ? ((value - min) / range) * 100 : 0;
              return (
                <div
                  key={index}
                  className="flex-1 bg-primary1 rounded-t-sm transition-all duration-200 hover:bg-opacity-50"
                  style={{ height: `${height}%` }}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
